import { GtmEventType, ProductWithAttributes, SFCCBasket } from '@gn-audio/jss-core';

export const calculateBasketSize = (basket?: SFCCBasket): number => {
  if (!basket) return 0;
  return (
    basket?.product_items?.reduce((sum, product) => {
      if (product.c_isService) {
        return sum;
      }
      return product.quantity + sum;
    }, 0) ?? 0
  );
};

type CreateEcommercePayloadParams = {
  eventType: GtmEventType;
  basket?: SFCCBasket;
  groups: ProductWithAttributes[];
  currency?: string;
  loginType?: string;
};

export const createEcommercePayload = ({
  eventType,
  basket,
  groups,
  currency = '',
  loginType,
}: CreateEcommercePayloadParams) => {
  const basketItems = basket?.product_items ?? [];
  const coupon = basket?.coupon_items?.length
    ? basket.coupon_items.map((c) => c.code).join(', ')
    : undefined;
  return {
    event: eventType,
    ecommerce: {
      currency,
      ...(basket && basket.product_total !== null && { value: basket.product_total }),
      ...(coupon && { coupon }),
      items: basketItems.map((item) => {
        const discountedPrice =
          item.price_after_item_discount !== undefined &&
          item.quantity !== null &&
          item.quantity > 0
            ? Math.round((item.price_after_item_discount / item.quantity) * 100) / 100
            : undefined;
        const adjustmentPrice = item.price_adjustments?.[0]?.price;
        const unitDiscount =
          adjustmentPrice !== null &&
          adjustmentPrice !== undefined &&
          item.quantity !== null &&
          item.quantity > 0
            ? Math.round((Math.abs(adjustmentPrice) / item.quantity) * 100) / 100
            : 0;
        return {
          item_name: item?.item_text || '',
          item_id: item?.product_id || '',
          ...(discountedPrice !== undefined && { price: discountedPrice }),
          discount: unitDiscount,
          item_brand:
            groups
              .find((group) => group.sku === item.product_id)
              ?.attributes?.find((attr) => attr.key === 'Product_Portfolio')?.value || '',
          item_category:
            groups
              .find((group) => group.sku === item.product_id)
              ?.attributes?.find((attr) => attr.key === 'Meta_Producttype')?.value || '',
          quantity: item.quantity,
        };
      }),
    },
    ...(loginType && { login_type: loginType }),
  };
};
